module.exports = __webpack_public_path__ + "static/media/logo-escuro.e8fef609.png";